import { useEffect } from 'react';
import { io, Socket } from 'socket.io-client';
import { API_BASE_URL } from '@api/baseUrl';
import { notificationsApi } from '@store/api/notifications/notificationsApi';
import { useAppDispatch, useAppSelector } from '@store/helpers';

export const useNotificationSocket = () => {
  const dispatch = useAppDispatch();
  const token = useAppSelector(state => state.auth.token);

  useEffect(() => {
    if (!token) {
      return;
    }

    const invalidateNotifications = () => {
      dispatch(notificationsApi.util.invalidateTags([{ type: 'Notifications', id: 'LIST' }]));
    };

    const socket: Socket = io(API_BASE_URL, {
      auth: { token: `Bearer ${token}` },
      autoConnect: false,
      transports: ['websocket'],
      reconnectionAttempts: 3,
    });

    socket.on('connect', invalidateNotifications);
    socket.on('notifications:update', invalidateNotifications);
    const connectTimeout = window.setTimeout(() => {
      socket.connect();
    }, 0);

    return () => {
      window.clearTimeout(connectTimeout);
      socket.off('connect', invalidateNotifications);
      socket.off('notifications:update', invalidateNotifications);
      if (socket.connected || socket.active) {
        socket.disconnect();
      }
    };
  }, [dispatch, token]);
};
